import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import Headline from 'components/Headline/Headline';
import SharePanelComponent from 'components/SharePanel/SharePanel';
import { Label } from 'components/SharePanel/SharePanel.styles';
import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

const columns = layout.columns.max;

export const Wrapper = styled(motion.div)`
  padding: 247px 0 0 0;

  display: grid;
  grid-template-columns:
    [out-left] 16px
    repeat(${columns}, [content] minmax(0px, 1fr))
    [out-right] 16px;

  color: ${colors.lighterMineShaft};

  ${mediaDesktop(`
    grid-template-columns: [out-left] 124px repeat(${columns}, [content] minmax(0px, 1fr)) [out-right] 124px;
  `)}

  ${mediaTablet(`
    padding: 153px 0 0 0;
  `)}

  em {
    font-style: italic;
  }

  a {
    text-decoration: underline;
  }

  *::selection {
    background: ${colors.black};
    color: ${colors.white};
    text-shadow: none;
  }

  *::-moz-selection {
    background: ${colors.black};
    color: ${colors.white};
    text-shadow: none;
  }
`;

export const HeadlineWrapper = styled.section`
  margin-bottom: 102px;
  grid-column: 2/-2;

  ${mediaTablet(`
    grid-column: content 1/out-right;
  `)}

  ${mediaDesktop(`
    grid-column: content 1/content 10;
    margin-bottom: 112px;
  `)}
`;

export const InsightHeadline = styled(Headline)`
  color: ${colors.lighterMineShaft};
`;

export const Content = styled.div`
  background-color: ${colors.white};
  grid-column: 1/ -1;
`;

export const SharePanel = styled(SharePanelComponent)`
  grid-column: 2/ -2;
  margin-bottom: 24px;
`;

export const LastSharePanel = styled(SharePanelComponent)`
  grid-column: 2/ -2;
  margin-bottom: 24px;
  flex-direction: column;
  align-items: flex-start !important;

  margin-bottom: 64px;

  ${mediaDesktop(
    css`
      grid-column: 5/-5;
      margin-bottom: 161px;
    `
  )}

  a {
    &:first-child {
      margin-left: 0;
    }
  }

  ${Label} {
    ${({ theme: { locale } }) => setTypography('heading5', locale)}
    margin-bottom: 20px;
  }
`;

export const ReadMoreWrapper = styled.div`
  grid-column: 1/ -1;

  display: flex;
  flex-direction: column;

  ${mediaTablet(css`
    flex-direction: row;
  `)}
`;
